<template>
  <div class="container">
    <van-nav-bar
        left-arrow
        title="分享二维码"
        @click-left="$router.go(-1)"
        left-text="">
    </van-nav-bar>

    <img :src="$getFileAccessHttpUrl(haibaoUrl)" style="width: 100%;height: 100%">
    <div style="margin: 16px;">
      <van-button
          round
          block
          type="danger"
          @click="makeHaiBao()">
        重新生成
      </van-button>
    </div>
  </div>
</template>

<script>
import {Cell, Tag, Button, Swipe, SwipeItem, DropdownMenu, DropdownItem, Card, Divider, Popup, SubmitBar} from 'vant';
import {postAction} from '@/api/manage';
import {Toast, Dialog} from 'vant'
import Vue from 'vue';

export default {
  components: {
    [Cell.name]: Cell, [Card.name]: Card, [Divider.name]: Divider, [Tag.name]: Tag, [Popup.name]: Popup,
    [Button.name]: Button, [DropdownItem.name]: DropdownItem, [SubmitBar.name]: SubmitBar,
    [Swipe.name]: Swipe, [DropdownMenu.name]: DropdownMenu,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      show: false,
      haibaoUrl: '',
      productId: this.$route.query.prodId,
      prodExtraFlag: this.$route.query.prodExtraFlag,
      sourceOrderSn: this.$route.query.sourceOrderSn,
      wx: this
    };
  },
  mounted() {
    this.getHaiBao()
  },
  methods: {
    makeHaiBao() {
      const that = this;
      Toast.loading({message: '加载中...'});
      postAction('/web/api/index/toMakeQr', {
        productId: this.productId,
        prodExtraFlag: this.prodExtraFlag,
        sourceOrderSn: this.sourceOrderSn
      }).then(function (response) {
        console.log(response.result)
        Toast('生成成功');
        that.haibaoUrl = response.result.haiBaoUrl + "?date=" + new Date().getTime();
      })
    },
    getHaiBao() {
      Toast.loading({message: '加载中...'});
      const that = this;
      postAction('/web/api/index/getHaiBaoUrl', {
        productId: this.productId,
        prodExtraFlag: this.prodExtraFlag,
        sourceOrderSn: this.sourceOrderSn
      }).then(function (response) {
        console.log(response.result)
        Toast.clear()
        that.haibaoUrl = response.result.haiBaoUrl + "?date=" + new Date().getTime();
      })
    },
  }
};
</script>

<style lang="less">
.container {
  //background-color: rgba(220, 220, 220, 0.52);
}

.wxToOrder .van-cell__title {
  margin: 5px 0px !important;
}

.wxToOrder .van-cell__value {
  margin: 5px 0px !important;
}

.wxToOrder .van-cell__right-icon {
  margin: 5px 0px !important;
}

.van-card {
  background-color: white;
}

.wxToOrder .van-field__control {
  margin-top: -15px !important;
  margin-left: -10px !important;
}

.wxToOrder .van-cell__right-icon {
  margin-top: 10px !IMPORTANT;
}
</style>
